import { couponBenefitText } from '@euler/functions/apdm/couponRedemption';
import { CouponCampaignPublicViewItem } from '@euler/model/apdm';
import { Image, Text, View } from 'react-native';
import { useTheme } from 'styled-components';

export interface ApdmCouponPreviewProps {
  title: string;
  storeName: string;
  startsAt: string;
  endsAt: string;
  items: readonly CouponCampaignPublicViewItem[];
  poster?: {
    uri: string;
    contentType: 'image/jpeg' | 'image/png';
    width: number;
    height: number;
  };
}
export function ApdmCouponPreview(props: ApdmCouponPreviewProps) {
  const theme = useTheme();
  const poster = props.poster;
  const validPoster =
    poster &&
    ['image/jpeg', 'image/png'].includes(poster.contentType) &&
    poster.width > 0 &&
    poster.height > 0;
  return (
    <View style={{ padding: 16, backgroundColor: theme.page.background }}>
      <Text style={{ color: theme.label.color, fontWeight: '600' }}>
        {props.title}
      </Text>
      <Text style={{ color: theme.label.color }}>{props.storeName}</Text>
      <Text style={{ color: theme.label.color }}>
        {props.startsAt} 至 {props.endsAt}
      </Text>
      {props.items.map((item, index) => (
        <View key={index} style={{ marginTop: 12 }}>
          <Text style={{ color: theme.label.color }}>
            {item.label} · {item.qty} {item.qtyUnit ?? '份'}
          </Text>
          <Text style={{ color: theme.label.color }}>
            {couponBenefitText(item.benefit)}
          </Text>
        </View>
      ))}
      {validPoster && (
        <Image
          accessibilityLabel="优惠券海报预览"
          source={{ uri: poster.uri }}
          resizeMode="contain"
          style={{
            width: '100%',
            aspectRatio: poster.width / poster.height,
            marginTop: 16,
          }}
        />
      )}
      {poster && !validPoster && (
        <Text style={{ color: theme.label.color }}>
          仅支持 JPEG 或 PNG 海报。
        </Text>
      )}
    </View>
  );
}
